import { hitsApi } from '../../../api';
import type { UpdateHitInput, Hit } from '../../../types';
import type { GameStateGetter } from '../types';

export const createUpdateHit = (get: GameStateGetter) => {
  return async (boardId: string, hitId: string, input: UpdateHitInput): Promise<Hit> => {
    const hit = await hitsApi.update(boardId, hitId, input);
    await get().fetchHits(boardId);
    return hit;
  };
};
